// Referencias de la plantilla semanal a nivel e instructor.
//
// El back hace `populate` de `eventos.nivel_id` y `eventos.instructor_id`, así que
// llegan como objeto `{ _id, nombre, ... }` aunque el tipo diga `string`. Si la
// entidad ya no existe (antes de B1 se podía borrar estando en uso, o alguien la
// borra a mano en la BD) el populate devuelve `null`, y como `typeof null ===
// 'object'` el patrón `typeof x === 'object' ? x.nombre : x` revienta la pantalla.
// Estos helpers cubren los tres casos: objeto poblado, id en texto y referencia
// perdida.

export const refFaltante = (ref: unknown): boolean =>
    ref === null || ref === undefined || ref === '';

// Id de la referencia, o '' si falta: así el <select> queda en "Seleccione" y la
// validación del formulario obliga a reasignar antes de guardar.
export const refId = (ref: unknown): string => {
    if (refFaltante(ref)) return '';
    if (typeof ref === 'object') return String((ref as { _id?: unknown })._id ?? '');
    return String(ref);
};

// Nombre para mostrar, o null si la referencia falta (el llamador decide el texto).
export const refNombre = (ref: unknown): string | null => {
    if (refFaltante(ref)) return null;
    if (typeof ref === 'object') return (ref as { nombre?: string }).nombre ?? null;
    return String(ref);
};

interface PlantillaConEventos {
    numero_plantilla: number;
    eventos: Array<{ nivel_id: unknown; instructor_id: unknown; dia: string; horaInicio: string }>;
}

// Clases de las plantillas con nivel o instructor perdido, p. ej. ["P1 Lunes 17:30"].
export const clasesSinReferencia = (plantillas: PlantillaConEventos[]): string[] =>
    plantillas.flatMap(plantilla =>
        plantilla.eventos
            .filter(evento => refFaltante(evento.nivel_id) || refFaltante(evento.instructor_id))
            .map(evento => `P${plantilla.numero_plantilla} ${evento.dia} ${evento.horaInicio}`)
    );
